import PropTypes from 'prop-types';

import { Button, SvgIcon, Typography } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import { commentIcon, disabledCommentIcon } from '../../../res/svg/icons';

const CommentsButton = (props) => {
  const { t } = useTransl();
  const { onClick, commentsCount, disabled } = props;
  const label = `${commentsCount} ${t('title.post_comment', {
    count: commentsCount,
  })}`;

  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      sx={{ display: 'flex', gap: '0.5rem', color: 'inherit' }}
    >
      <SvgIcon viewBox="0 0 32 32">
        {disabled ? disabledCommentIcon : commentIcon}
      </SvgIcon>
      <Typography>{label}</Typography>
    </Button>
  );
};

CommentsButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  commentsCount: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default CommentsButton;
